module.exports = __webpack_public_path__ + "static/media/pamain-light.3122ffd0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-light.woff2
// module id = ./src/assets/fonts/pamain-light.woff2
// module chunks = 6